import { MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.TEXT_BG_PALETTE,
        content: i18n.t<string>('字体突出显示'),
        popUpStyle: { padding: 0 },
    },
];
